
<template>
<v-card
    v-if="!mobileBereakPoint"
    max-height="50%"
    min-width="25%"
    max-width="36%"
    class="mb-2 ml-2 mr-2 mx-auto pois-list clearPadding"
    style="position:absolute; bottom:20px;left:20px;z-index:2;overflow-y:auto; overflow-x:hidden; "
>
<v-expansion-panels v-if="true" v-model="expanded"   flat accordion tile>
    <v-expansion-panel class="clearPadding" flat accordion tile>
    <v-expansion-panel-header  color='primary'><h4 style="color:white" class="font-weight-light">{{ $t('vehiclesInPoi')}}</h4></v-expansion-panel-header>
    <v-expansion-panel-content class="clearPadding">
    <v-expansion-panels v-for="(poi,poiIndex) of pois" :key="poiIndex" v-model="expanded"  flat accordion tile>
    <v-expansion-panel>
        <v-expansion-panel-header style="color:white" color="secondary">{{ poi.poi }}</v-expansion-panel-header>
        <v-expansion-panel-content class="clearPadding">
        <ul>
          <li class="clearPadding" v-for="(vehicle,vehicleIndex) of poi.vehicles" :key="vehicleIndex" v-if="poi.vehicles.length > (vehicleIndex + 1)"> {{vehicle.vehicleLabel}} &nbsp|&nbsp</li>
          <li v-else class="clearPadding"> {{vehicle.vehicleLabel}} </li>
        </ul>
        </v-expansion-panel-content>
    </v-expansion-panel>
    </v-expansion-panels>
    </v-expansion-panel-content>
    </v-expansion-panel>
</v-expansion-panels>
</v-card>
<v-card
  v-else
  width="auto"
  height="auto"
>
<v-expansion-panels v-if="pois.length" v-model="expanded"   flat accordion tile>
    <v-expansion-panel class="clearPadding" flat accordion tile>
    <v-expansion-panel-header  color='primary'><h4 style="color:white" class="font-weight-light"> {{ $t('vehiclesInPoi')}} </h4></v-expansion-panel-header>
    <v-expansion-panel-content class="clearPadding">
    <v-expansion-panels v-for="(poi,poiIndex) of pois" :key="poiIndex" v-model="expanded"  flat accordion tile>
    <v-expansion-panel>
        <v-expansion-panel-header style="color:white" color="secondary">{{ poi.poi }}</v-expansion-panel-header>
        <v-expansion-panel-content class="clearPadding">
        <ul>
          <li class="clearPadding" v-for="(vehicle,vehicleIndex) of poi.vehicles" :key="vehicleIndex" v-if="poi.vehicles.length > (vehicleIndex + 1)"> {{vehicle.vehicleLabel}} &nbsp|&nbsp</li>
          <li v-else class="clearPadding"> {{vehicle.vehicleLabel}} </li>
        </ul>
        </v-expansion-panel-content>
    </v-expansion-panel>
    </v-expansion-panels>
    </v-expansion-panel-content>
    </v-expansion-panel>
</v-expansion-panels>
</v-card>
</template>

<script>
import { mapState } from 'vuex'
import mapMixin from '@/components/v2/mapMixin.js'

export default {
  name: 'PoiList',
  data() {
    return {
      pois: [],
      expanded: 0
    }
  },
  mixins: [mapMixin],
  computed: {
    ...mapState('map', ['vehicles']),
    mobileBereakPoint: function() {
      return this.$vuetify.breakpoint.smAndDown
    }
  },
  watch: {
    vehicles: {
      handler() {
        var that = this
        this.pois = []
        this.vehicles.forEach(x => {
          if (x.shouldDisplay() && x.poi != null && x.poi.name) {
            if (that.pois.filter(y => y.poi == x.poi.name).length == 0) {
              that.pois.push({
                poi: x.poi.name,
                vehicles: []
              })
            }
          }
        })
        that.pois.sort(function(a, b) {
          return a.poi.localeCompare(b.poi)
        })
        this.vehicles.forEach(x => {
          if (x.shouldDisplay() && x.poi != null && x.poi.name) {
            that.pois
              .filter(y => y.poi == x.poi.name)[0]
              .vehicles.push({
                vehicleLabel: x.vehicleLabel,
                timestamp: x.poiEnteredAt
              })
          }
        })
        that.pois.forEach(x => {
          x.vehicles.sort(function(a, b) {
            return new Date(a.timestamp) - new Date(b.timestamp)
          })
        })
      },
      deep: true
    }
  }
}
</script>

<style scoped>
.v-expansion-panel--active > .v-expansion-panel-header {
  min-height: 30px;
}

.pois-list li {
  font-size: 12px;
}

.v-expansion-panel-header {
  padding: 10px;
  min-height: 50px;
}

.clearPadding {
  padding: 0px !important;
}

ul {
  list-style-type: none;
}

ul > li {
  display: inline-block;
}
</style>
